import { render } from "./MessengerModal.vue?vue&type=template&id=2edfa3bc&scoped=true"
import script from "./MessengerModal.vue?vue&type=script&lang=js"
export * from "./MessengerModal.vue?vue&type=script&lang=js"

import "./MessengerModal.vue?vue&type=style&index=0&id=2edfa3bc&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edfa3bc"]])

export default __exports__